module.exports = __webpack_public_path__ + "img/poster.2b9d0d6e.jpg";